import { useState, useCallback } from 'react'
import { getExamsResults } from '../api/laboratories'
import { normalizeExamResultsList } from '../utils/normalizer/labsNormalizer'

const inFlightLabResultsRequests = {}

export const useLabResultsData = () => {
	const [data, setData] = useState([])
	const [totalPages, setTotalPages] = useState(1)
	const [currentPage, setCurrentPage] = useState(1)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const fetchData = useCallback(
		async ({
			items = [],
			currentPage = 1,
			itemsPerPage = 10,
			totalPages = 1,
			clinic = [],
			order = null,
			fecha = null,
			patientERID = 0,
			sortBy = null
		} = {}) => {
			setLoading(true)
			setError(null)
			try {
				const postData = {
					items: items,
					pagina: currentPage,
					itemsPorPagina: itemsPerPage,
					totalPaginas: totalPages,
					clinica: clinic,
					nOrden: order,
					fecha: fecha,
					pacienteERID: patientERID,
					Orden: sortBy
				}
				const requestKey = JSON.stringify(postData)

				if (!inFlightLabResultsRequests[requestKey]) {
					inFlightLabResultsRequests[requestKey] = getExamsResults(postData).finally(() => {
						delete inFlightLabResultsRequests[requestKey]
					})
				}

				const res = await inFlightLabResultsRequests[requestKey]
				const normalizeLabsData = normalizeExamResultsList(res.data?.items)
				setData(normalizeLabsData)
				setTotalPages(res.data?.totalPaginas || 1)
				setCurrentPage(res.data?.pagina || 1)
			} catch (err) {
				setError(err)
				setData([])
			} finally {
				setLoading(false)
			}
		},
		[]
	)

	return {
		data,
		totalPages,
		currentPage,
		loading,
		error,
		fetchData
	}
}
